import React, { useRef, useState, useEffect } from 'react';
import { Upload, X, Loader } from 'lucide-react';
import { adminApi, fileUrl } from '../../api/client';

export default function PhotoUpload({ value, onChange, uploadApi = adminApi.uploadFile }) {
  const [busy, setBusy] = useState(false);
  const [preview, setPreview] = useState(fileUrl(value) || null);

  useEffect(() => {
    setPreview(value ? fileUrl(value) : null);
  }, [value]);
  const inputRef = useRef(null);

  const readFile = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => resolve(e.target.result);
      reader.onerror = () => reject(reader.error);
      reader.readAsDataURL(file);
    });

  const handleFile = async (file) => {
    if (!file || !file.type.startsWith('image/')) return;
    setBusy(true);
    try {
      const dataUrl = await readFile(file);
      setPreview(dataUrl);
      const res = await uploadApi(file);
      if (res.url) onChange?.(res.url);
    } catch (err) {
      console.error('Upload error:', err);
    } finally {
      setBusy(false);
    }
  };

  const handleChange = (e) => {
    const [file] = e.target.files;
    handleFile(file);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const [file] = e.dataTransfer.files;
    handleFile(file);
  };

  const clear = () => {
    setPreview(null);
    onChange?.('');
    if (inputRef.current) inputRef.current.value = '';
  };

  return (
    <div
      className="photo-upload"
      onDragOver={(e) => e.preventDefault()}
      onDrop={handleDrop}
    >
      <input
        id="photo-upload-input"
        type="file"
        ref={inputRef}
        accept="image/jpeg,image/png,image/webp"
        onChange={handleChange}
        style={{ display: 'none' }}
      />

      {!preview ? (
        <label
          htmlFor="photo-upload-input"
          className="photo-upload-zone"
          aria-label="Choisir une photo"
        >
          {busy ? <Loader size={16} className="spin" /> : <Upload size={16} />}
          {busy ? 'Chargement…' : 'Glisser-déposer ou cliquer pour ajouter une photo'}
        </label>
      ) : (
        <div className="photo-upload-preview">
          <img
            src={preview}
            alt="Aperçu"
            onError={() => {
              console.warn('Image preview failed for', preview);
              setPreview(null);
            }}
          />
          <button type="button" onClick={clear} aria-label="Supprimer">
            <X size={14} />
          </button>
        </div>
      )}

      <p className="dform-hint">JPG, PNG ou WebP. Max 20 Mo.</p>
    </div>
  );
}
